// Import model
import { OtgCarpetCatalogStyleCondition } from '../models/OtgCarpetCatalogStyleCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgCarpetCatalogStyleIndexedFields } from '../models/OtgCarpetCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgCarpetCatalogStyleIndexedFieldsSerializer } from './OtgCarpetCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgCarpetCatalogStyleCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgCarpetCatalogStyleConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgCarpetCatalogStyleCondition instance
   */
  static deserialize(json: string): OtgCarpetCatalogStyleCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgCarpetCatalogStyleCondition instance
   */
  static fromObject(obj: any): OtgCarpetCatalogStyleCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgCarpetCatalogStyleCondition');
    }


    const instance: OtgCarpetCatalogStyleCondition = {
      fieldName: obj['fieldName'] as OtgCarpetCatalogStyleIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgCarpetCatalogStyleCondition instances
   */
  static deserializeArray(json: string): OtgCarpetCatalogStyleCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgCarpetCatalogStyleCondition instance to a JSON string
   */
  static serialize(instance: OtgCarpetCatalogStyleCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgCarpetCatalogStyleCondition instance to a plain object
   */
  static toObject(instance: OtgCarpetCatalogStyleCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgCarpetCatalogStyleCondition instances to a JSON string
   */
  static serializeArray(instances: OtgCarpetCatalogStyleCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
